import { Container } from 'ui';
import { Stack } from '@koob/margaret';
import { EditorField, SelectField } from 'components/Fields';
import { KoobInputSelectField } from '@koob/ui';
import { EXPERIENCE_PROGRAM_SCHEMA } from '../Utilities/ExperienceValidationSchemas';
import { useTranslation } from 'react-i18next';
import { getThemes } from 'api/node/themes';
import { getSegments } from 'api/node/segments';

export const ExperienceProgram = ({ isReadOnly = false }) => {
  const { t } = useTranslation('experiences');

  return (
    <Container size="full">
      <Stack direction="column" gutterSize={1.5} size="full">
        <Stack
          gutterSize={0.5}
          size="full"
          style={{
            flexWrap: 'wrap',
            alignItems: 'stretch',
            justifyContent: 'space-between',
          }}
        >
          <Stack>
            <SelectField
              label={t('form.difficulty')}
              name="difficulty"
              valueField={'value'}
              options={[
                { label: t('form.beginner'), value: 'Beginner' },
                {
                  label: t('form.intermediate'),
                  value: 'Intermediate',
                },
                { label: t('form.advanced'), value: 'Advanced' },
                { label: t('form.expert'), value: 'Expert' },
              ]}
              disabled={isReadOnly}
            />
          </Stack>
        </Stack>

        <Stack gutterSize={1.5} size="full">
          <KoobInputSelectField
            label={t('form.segments')}
            name="segments"
            multiple
            query={getSegments}
            renderOption={({ displayName }) => displayName}
            renderValue={({ displayName }) => displayName}
            disabled={isReadOnly}
          />

          <KoobInputSelectField
            label={t('form.themes')}
            name="themes"
            multiple
            query={getThemes}
            renderOption={({ displayName }) => displayName}
            renderValue={({ displayName }) => displayName}
            disabled={isReadOnly}
          />
        </Stack>

        <Stack gutterSize={1.5} size="full">
          <EditorField
            name={'highlights'}
            label={t('form.highlights')}
            disabled={isReadOnly}
          />
        </Stack>
      </Stack>
    </Container>
  );
};

export const getSchema = () => EXPERIENCE_PROGRAM_SCHEMA;
